function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/// <reference path="../../types.d.ts" />
import { Button } from '../../components/button/button';
import { ButtonSize } from '../../core/enums';
import { ButtonVariant } from '../../core/enums';
import Input from '../../components/input/input';
import React from 'react';
import { GitTag } from '../../core/git-info';
// assets
import './login.scss';
import ContextChoiceForm from '../../views/context/context-choice-form';
import { Route } from 'react-router-dom';
import { Eula } from '../../views/eula/eula';
import { getStyledBackgroundImage } from '../../core/login/background-image';
import ServiceLines from '../../views/service-lines/service-line-choice-form';
import ForgotPasswordForm from '../../views/forgot-password/forgot-password-component';
import resetPasswordComponent from '../../views/forgot-password/reset-password-component';
import PasswordChangeForm from '../../views/password-change/password-change-component';
import { ConfirmEmailModal } from './confirm-email-modal/confirm-email-modal';
import ssoLoginComponent from '../../views/sso-login/sso-login-component';
import { Logotype4CBlack } from '@codametrix/verdigris';
const LoginForm = (props)=>{
    const { error, handleInputChange, handleSubmit, handleForgotPassword, submitting, message } = props;
    const handleForgotPasswordClick = (e)=>{
        if (e) {
            e.preventDefault();
            handleForgotPassword();
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsx("form", {
            className: "login-form",
            onSubmit: handleSubmit,
            children: /*#__PURE__*/ _jsxs("fieldset", {
                disabled: submitting,
                children: [
                    !!error && /*#__PURE__*/ _jsxs("div", {
                        className: "error-msg",
                        children: [
                            /*#__PURE__*/ _jsx("i", {
                                className: "fa fa-times-circle"
                            }),
                            " ",
                            typeof message === 'string' && message ? message : 'Login Failed: Invalid Username or Password'
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "form-group",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "form-row",
                                children: [
                                    /*#__PURE__*/ _jsx("label", {
                                        className: "form-label",
                                        htmlFor: "input-email-1",
                                        children: "Username"
                                    }),
                                    /*#__PURE__*/ _jsx(Input, {
                                        autoFocus: true,
                                        onChange: handleInputChange,
                                        name: 'username',
                                        placeholder: '',
                                        type: 'text',
                                        className: error ? 'form-input is-error' : 'form-input'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "form-row",
                                children: [
                                    /*#__PURE__*/ _jsx("label", {
                                        className: "form-label",
                                        htmlFor: "input-password-1",
                                        children: "Password"
                                    }),
                                    /*#__PURE__*/ _jsx(Input, {
                                        autoFocus: true,
                                        onChange: handleInputChange,
                                        name: 'password',
                                        placeholder: '',
                                        type: 'password',
                                        className: error ? 'form-input is-error' : 'form-input',
                                        id: "input-password-1"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "form-buttons",
                                children: [
                                    /*#__PURE__*/ _jsx(Button, {
                                        size: ButtonSize.MD,
                                        label: 'Login',
                                        variant: ButtonVariant.PRIMARY,
                                        name: "Login",
                                        dataTestId: "login",
                                        type: "submit"
                                    }),
                                    /*#__PURE__*/ _jsx(Button, {
                                        size: ButtonSize.MD,
                                        label: "Forgot Password",
                                        variant: ButtonVariant.LINKS,
                                        dataTestId: "forgotPassword",
                                        onClick: handleForgotPasswordClick
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var _React_Component;
class Login extends (_React_Component = React.Component) {
    handleSubmit(event) {
        event.preventDefault();
        this.props.doLogin(this.state);
    }
    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }
    render() {
        const { error, submitting, contexts, context, handleOrganizationChoice, message, handleForgotPassword, user, emailConfirmationModalOpen } = this.props;
        const bgStyle = getStyledBackgroundImage();
        return /*#__PURE__*/ _jsxs("div", {
            className: "exterior-container",
            children: [
                emailConfirmationModalOpen ? /*#__PURE__*/ _jsx(ConfirmEmailModal, {}) : null,
                /*#__PURE__*/ _jsx("div", {
                    className: "exterior-header",
                    style: bgStyle
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "exterior-body",
                    children: [
                        /*#__PURE__*/ _jsx(Route, {
                            path: "/eula/",
                            exact: true,
                            component: Eula
                        }),
                        /*#__PURE__*/ _jsx(Logotype4CBlack, {
                            titleText: "Codametrix",
                            iconClass: "exterior-icon"
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "column action-container",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "action",
                                    children: [
                                        /*#__PURE__*/ _jsx(Route, {
                                            path: "/update-password/",
                                            exact: true,
                                            component: PasswordChangeForm
                                        }),
                                        /*#__PURE__*/ _jsx(Route, {
                                            path: "/choose/context/",
                                            exact: true,
                                            render: ()=>{
                                                return /*#__PURE__*/ _jsx(ContextChoiceForm, {
                                                    context: context && context.activeContext,
                                                    handleOrganizationChoice: handleOrganizationChoice,
                                                    contexts: contexts,
                                                    user: user
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx(Route, {
                                            path: "/choose/service-line/",
                                            exact: true,
                                            component: ServiceLines
                                        }),
                                        /*#__PURE__*/ _jsx(Route, {
                                            path: "/forgot-password/",
                                            exact: true,
                                            component: ForgotPasswordForm
                                        }),
                                        /*#__PURE__*/ _jsx(Route, {
                                            path: "/forgot-password/reset",
                                            exact: true,
                                            component: resetPasswordComponent
                                        }),
                                        /*#__PURE__*/ _jsx(Route, {
                                            path: "/sso/:orgCode?",
                                            exact: true,
                                            component: ssoLoginComponent
                                        }),
                                        /*#__PURE__*/ _jsx(Route, {
                                            path: "/",
                                            exact: true,
                                            render: ()=>{
                                                return /*#__PURE__*/ _jsx(LoginForm, {
                                                    submitting: submitting,
                                                    error: error,
                                                    handleInputChange: this.handleInputChange,
                                                    handleSubmit: this.handleSubmit,
                                                    message: message,
                                                    handleForgotPassword: handleForgotPassword
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "warning-message-container",
                                    children: /*#__PURE__*/ _jsxs("p", {
                                        className: 'warning-message',
                                        children: [
                                            "By clicking the Login button, you confirm that you have the right and authority to access, use and disclose protected health information (PHI) on this platform. Unauthorized users are expressly prohibited.",
                                            /*#__PURE__*/ _jsxs("span", {
                                                className: "imo-message",
                                                children: [
                                                    "Powered by IMO® Terminology. © ",
                                                    new Date().getFullYear()
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(GitTag, {})
            ]
        });
    }
    constructor(props){
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
}
_define_property(Login, "defaultProps", {
    doLogin: ()=>{},
    error: false
});
export default Login;
